package com.bikompanion.data.cache

import com.bikompanion.domain.BikeParkingSpot

/** Cached racks with the moment they were fetched, which is what decides a refetch. */
data class ParkingCacheEntry(
    val spots: List<BikeParkingSpot>,
    val updatedAtEpochMillis: Long,
)
